import { View, Model, Template } from "@lernetz/ts-lib";
import { ViewConfig } from "@lernetz/ts-lib/src/view/View";
import { Subscription } from "@lernetz/ts-lib/src/Signal";
import { observeProperties } from "@lernetz/ts-lib/src/Observer";

var defaultStyles = {
    'p': 'text-style -para',
    'b': 'text-style -b',
    'i': 'text-style -i',
    'a': 'text-style -a',
    'ul': 'text-style -list',
    'ol': 'text-style -list',
}

export class Html extends Model {
    styles:{[key:string]:string};
    html:string;
}

export class HtmlView extends View<Html> {

    subscription: Subscription;

    constructor( config?:ViewConfig<Html> ) {
        super( { data:new Html( { styles:defaultStyles } ), ...config } );
    }

    init() {
        this.subscription = observeProperties( this.data, 'html' ).propertyChange.filter( e => e.name == 'html' ).subscribe( this.update.bind( this ) );
        this.update();
    }

    deinit() {
        this.subscription.unsubscribe();
    }

    update() {
        this.node.innerHTML = this.data.html ? this.data.html : '';
        this.applyStyles();
        this.resolveViews();
    }

    resolveViews() {

        // remove view attribute to prevent reinitalize
        let viewName = this.node.getAttribute( 'view' );
        this.node.removeAttribute( 'view' );

        let sub = new Template( this.node );
        // inject parent data to resolve from outside
        sub.context.data = this.context.parent.data;
        // add this context to prototype chaine of sub context
        Object.setPrototypeOf( sub.context, this.context );

        sub.render();

        // reapply view name
        this.node.setAttribute( 'view', viewName );
    }

    applyStyles() {
        const walker = document.createTreeWalker( this.node, NodeFilter.SHOW_ELEMENT );
        while( walker.nextNode() ) {
            const key = walker.currentNode.nodeName.toLowerCase();
            if( key in this.data.styles ) {
                const element = walker.currentNode as Element;
                element.classList.add.apply( element.classList, this.data.styles[key].split( ' ' ) );
            }
        }
    }
}
